import React from 'react';
import { Box, Hidden } from '@material-ui/core';
import { Button } from 'components/core';
import { ContactTreasureSupportLink } from 'modules/support/components/contact-treasure-support-link/contact-treasure-support-link';

export const RequestDemoButton: React.FC = () => {
  return (
    <>
      <Hidden mdUp>
        <Box px={2}>
          <ContactTreasureSupportLink subject="Request a Demo">
            Request a Demo
          </ContactTreasureSupportLink>
        </Box>
      </Hidden>

      <Hidden smDown>
        <Box px={2}>
          <ContactTreasureSupportLink subject="Request a Demo">
            <Button variant="contained">Request a Demo</Button>
          </ContactTreasureSupportLink>
        </Box>
      </Hidden>
    </>
  );
};
